<template>
  <v-navigation-drawer
    v-model="drawer"
    :color="color"
    dark
    app
    clipped
    temporary
  >
    <v-list dense>
      <v-list-item>
        <!--<v-list-item-avatar>
          <v-img src="https://randomuser.me/api/portraits/men/78.jpg" />
        </v-list-item-avatar>-->
  
        <v-list-item-content>
          <v-list-item-title> {{ currentUser }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  
    <v-divider />
    <v-list dense>
      <v-list-item
        v-for="menu in navMenus"
        :key="menu.title"
        :to="menu.route"
        link
      >
        <v-list-item-icon>
          <v-icon>{{ menu.icon }}</v-icon>
        </v-list-item-icon>
  
        <v-list-item-content>
          <v-list-item-title>{{ menu.title }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <template v-slot:append>
      <div class="ma-9 pa-9">
        <ps-button
          block
          width="100%"
          route-link="Logout"
        >
          Logout
        </ps-button>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
export default {
    name: "Menu",
    props: {
        isOpen: Boolean,
        color:{
            type:String,
            default:""
        }
    },
    data() {
        return {
            drawer: null, 
            navMenus: [
                { title: "Home", icon: "dashboard", route: "/admin/home" },
                { title: "Users", icon: "person", route: "/admin/UserAdmin" },
                { title: "Clients", icon: "hotel", route: "/admin/PsClientAdmin" }
            ]
        };
    },
    computed: {
        currentUser() {
            return this.$store.getters.currentUser;
        }
    },
    watch: {
        isOpen() {
            this.drawer = this.isOpen;
        }
    }
};
</script>
